// All pages that rely on 3rd party components (other than MUI) are
// loaded asynchronously, to keep the initial JS bundle to a minimum size

// Layouts
import AuthLayout from './layouts/Auth';
import DashboardLayout from './layouts/Dashboard';

// Guards
import AuthGuard from './components/guards/AuthGuard';

// Auth components
import Page404 from './pages/auth/Page404';
import Page500 from './pages/auth/Page500';
import SignIn from './pages/auth/SignIn';
import ZendeskSSO from './pages/auth/ZendeskSSO';
import Welcome from './pages/auth/welcome/Welcome';
import { ZitadelCallback, ZitadelWelcome } from './pages/auth/zitadel/ZitadelPages';
import { isZitadelAuth } from './contexts/auth/zitadelContext';

// Page components
import Branding from './pages/Branding/Branding';
import Accounts from './pages/accounts/Accounts';
import AgreementsView from './pages/agreements/Agreements';
import AgreementFormView from './pages/agreements/components/agreement/AgreementFormView';
import HomePage from './pages/home/HomePage';
import InteralSearch from './pages/internalSearch/InternalSearch';
import Statistics from './pages/statistics/Statistics';
import { AdminManagement } from './pages/adminManagement/AdminManagement';
import { MasterList } from './pages/masterList/MasterList';
import { JournalsIntelligence } from './pages/journalsIntelligence/JournalsIntelligence';
import { Announcements } from './pages/announcements/Announcements';

const routes = () => [
  {
    path: '',
    element: (
      <AuthGuard>
        <DashboardLayout />
      </AuthGuard>
    ),
    children: [
      {
        path: '',
        element: (
          <AuthGuard>
            <HomePage />
          </AuthGuard>
        ),
      },
      {
        path: 'statistics',
        element: (
          <AuthGuard>
            <Statistics />
          </AuthGuard>
        ),
      },
      {
        path: 'internal-search',
        element: (
          <AuthGuard>
            <InteralSearch />
          </AuthGuard>
        ),
      },

      {
        path: 'agreements',
        element: (
          <AuthGuard>
            <AgreementsView />
          </AuthGuard>
        ),
      },
      {
        path: 'agreements/:agreementId',
        element: <AgreementFormView />,
      },
      {
        path: 'agreements/add',
        element: (
          <AuthGuard>
            <AgreementFormView />
          </AuthGuard>
        ),
      },
      {
        path: 'admin-management',
        element: (
          <AuthGuard>
            <AdminManagement />
          </AuthGuard>
        ),
      },
      {
        path: 'branding',
        element: (
          <AuthGuard>
            <Branding />
          </AuthGuard>
        ),
      },
      {
        path: 'accounts',
        element: (
          <AuthGuard adminOnly>
            <Accounts />
          </AuthGuard>
        ),
      },
      {
        path: 'master-list',
        element: (
          <AuthGuard adminOnly requireSelectedAccount="admin">
            <MasterList />
          </AuthGuard>
        ),
      },
      {
        path: 'journal-intelligence',
        element: (
          <AuthGuard adminOnly>
            <JournalsIntelligence />
          </AuthGuard>
        ),
      },
      {
        path: 'announcements',
        element: (
          <AuthGuard adminOnly>
            <Announcements />
          </AuthGuard>
        ),
      },

    ],
  },

  {
    path: 'welcome',
    // With REACT_APP_AUTH_PROVIDER=zitadel, sign-in happens on our login app.
    element: isZitadelAuth ? <ZitadelWelcome /> : <Welcome />,
  },

  ...(isZitadelAuth ? [{ path: 'callback', element: <ZitadelCallback /> }] : []),

  {
    path: 'auth',
    element: <AuthLayout />,
    children: [
      {
        path: 'sign-in',
        element: <SignIn />,
      },
      {
        path: 'zendesk-sso',
        element: <ZendeskSSO />,
      },
      {
        path: '404',
        element: <Page404 />,
      },
      {
        path: '500',
        element: <Page500 />,
      },
    ],
  },

  {
    path: '*',
    element: <AuthLayout />,
    children: [
      {
        path: '*',
        element: <Page404 />,
      },
    ],
  },
];

export default routes;
